import { useState, useEffect } from "react";
import photo from "./photoo.jpeg";
const G = "#b8960c";

function GoldTag({ children }) {
  return <span className="inline-block px-2 py-0.5 text-[11px] border rounded-sm mr-1 mt-1 font-medium" style={{ borderColor: G + "44", color: G, background: G + "11" }}>{children}</span>;
}

function TypeWriter({ texts, speed = 40 }) {
  const [display, setDisplay] = useState("");
  const [textIndex, setTextIndex] = useState(0);
  const [charIndex, setCharIndex] = useState(0);
  const [done, setDone] = useState(false);

  useEffect(() => {
    if (done) return;
    const current = texts[textIndex];
    if (charIndex < current.length) {
      const t = setTimeout(() => {
        setDisplay(prev => prev + current[charIndex]);
        setCharIndex(c => c + 1);
      }, speed);
      return () => clearTimeout(t);
    } else if (textIndex < texts.length - 1) {
      const t = setTimeout(() => {
        setDisplay(prev => prev + "\n");
        setTextIndex(i => i + 1);
        setCharIndex(0);
      }, 300);
      return () => clearTimeout(t);
    } else {
      setDone(true);
    }
  }, [charIndex, textIndex, done, texts, speed]);

  return (
    <span style={{ whiteSpace: "pre-line" }}>
      {display}
      {!done && <span style={{ color: G, animation: "blink 1s step-end infinite" }}>|</span>}
    </span>
  );
}

export default function About({ refs, goTo }) {
  const [showContent, setShowContent] = useState(false);
  const [showStats, setShowStats] = useState(false);

  useEffect(() => {
    const t1 = setTimeout(() => setShowContent(true), 800);
    const t2 = setTimeout(() => setShowStats(true), 1200);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, []);

  return (
    <section id="About" ref={el => (refs.current["About"] = el)} className="py-10">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 items-center">

        <div className="flex flex-col items-center gap-4 order-first md:order-last">
          <div className="relative w-full max-w-[260px] md:max-w-[300px]">
            <div className="absolute -top-2 -right-2 w-full h-full border rounded-sm z-0" style={{ borderColor: G + "44" }} />
            <div className="relative z-10 w-full h-[300px] md:h-[380px] overflow-hidden rounded-sm">
              <img src={photo} alt="Wilson Omonzokpia" className="w-full h-full object-cover object-top grayscale hover:grayscale-0 transition-all duration-700" />
            </div>
          </div>
          <div className="w-full max-w-[260px] md:max-w-[300px] border border-white/8 rounded-sm px-4 py-3" style={{ background: "#1a1a1a" }}>
            <div className="space-y-1.5 mb-3">
              <div className="text-xs text-gray-500">📍 Berlin, Germany</div>
              <div className="text-xs text-gray-500">📧 umoxwilson@gmail.com</div>
              <div className="text-xs text-gray-500">📞 017616040167</div>
            </div>
            <div className="pt-3 border-t border-white/8">
              <GoldTag>English C2</GoldTag>
              <GoldTag>Italian B2</GoldTag>
              <GoldTag>German B1</GoldTag>
            </div>
          </div>
        </div>

        <div className="order-last md:order-first">
          <p className="text-xs tracking-[0.25em] uppercase mb-3 font-semibold" style={{ color: G }}>
            <TypeWriter texts={["Available for Work"]} speed={60} />
          </p>
          <h1 style={{ fontFamily: 'Playfair Display, serif' }} className="text-4xl sm:text-5xl md:text-6xl font-black text-white leading-tight mb-3">
            <TypeWriter texts={["Wilson", "Omonzokpia"]} speed={80} />
          </h1>
          <div className="w-14 h-0.5 mb-4" style={{ background: G }} />

          {showContent && (
            <>
              <p className="text-xs font-mono mb-3" style={{ color: G }}>
                <TypeWriter texts={["IT Specialist · System Admin · Software Engineer"]} speed={45} />
              </p>
              <p className="text-sm text-gray-400 leading-loose mt-2 mb-6">
                <TypeWriter
                  texts={["Berlin-based IT Specialist with 4+ years of experience managing hardware devices and operating systems, Active Directory, SaaS ecosystems, and end-to-end employee lifecycle processes. Skilled in troubleshooting hardware, software, and networks. BSc in Software Engineering from Amsterdam Tech."]}
                  speed={15}
                />
              </p>
            </>
          )}

          {showStats && (
            <>
              <div className="flex gap-3 flex-wrap mb-8">
                <button onClick={() => goTo("Contact")} className="px-6 py-2.5 text-xs font-bold tracking-widest uppercase transition-all duration-300 rounded-sm" style={{ background: G, color: "#0f0f0f" }}>
                  Get in Touch
                </button>
                <button onClick={() => goTo("Experience")} className="px-5 py-2.5 text-xs font-medium border border-white/15 text-gray-300 hover:border-yellow-600/50 transition-all rounded-sm">
                  View Experience →
                </button>
              </div>
              <div className="grid grid-cols-4 gap-2 sm:gap-4 pt-5 border-t border-white/8">
                {[["4+", "Years"], ["200+", "Users"], ["15+", "Scripts"], ["99.5%", "Uptime"]].map(([n, l]) => (
                  <div key={l} className="text-center">
                    <div style={{ fontFamily: 'Playfair Display, serif', color: G }} className="text-xl sm:text-2xl font-black">{n}</div>
                    <div className="text-[9px] sm:text-[10px] text-gray-600 tracking-widest uppercase mt-0.5">{l}</div>
                  </div>
                ))}
              </div>
            </>
          )}
        </div>

      </div>
    </section>
  );
}
